var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0712891,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6535 10.6104H9.34668L11.0001 15.4842L12.6535 10.6104Z",
    fill: "#2f4cdd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5543 10.6104L11.3978 16.9671L11.3624 17.0715L17.9381 10.6104H13.5543Z",
    fill: "#2f4cdd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44583 10.6104H4.06201L10.6377 17.0715L8.44583 10.6104Z",
    fill: "#2f4cdd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 6.07129L8.74219 9.33721L10.7734 6.07129H6.71094Z",
    fill: "#2f4cdd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2264 6.07129L13.2577 9.33721L15.2889 6.07129H11.2264Z",
    fill: "#2f4cdd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 7.34277L9.53308 9.7012H12.4667L10.9999 7.34277Z",
    fill: "#2f4cdd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9756 6.52539L4 9.70189H7.95119L5.9756 6.52539Z",
    fill: "#2f4cdd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0243 6.52539L14.0487 9.70186H17.9999L16.0243 6.52539Z",
    fill: "#2f4cdd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.9b30811c479ae5214fdff5386e677bde.svg";
export { ForwardRef as ReactComponent };